<!-- eslint-disable vue/require-prop-type-constructor -->
<script>
import { ref, watch } from "vue";
import EditCourseDatesModal from "./modals/EditCourseDatesModal.vue";

export default {
    props: {
        repetition: String,
        courseName: String,
        courseDates: String,
        course: Object,
        hideEdit: {
            type: Boolean,
            default: false,
        },
        showModalSpinner: {
            type: Boolean,
            default: false,
        },
        mp: {
            type: Boolean,
            default: false,
        },
        hideModal: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["submit", "delete"],
    components: { EditCourseDatesModal },
    setup(props, { emit }) {
        const showModal = ref(false);

        function submit(data) {
            emit("submit", data);
            if (!props.mp) {
                showModal.value = false;
            }
        }

        async function submitDelete() {
            emit("delete");
            showModal.value = false;
        }

        // eslint-disable-next-line no-unused-vars
        watch(() => props.hideModal, (newValue, oldValue) => {
            if (newValue) {
                showModal.value = false;
            }
        });

        return {
            submit,
            showModal,
            submitDelete,
            ...props,
        };
    },
};

</script>

<template>
    <div>
        <div class="title-sub-text" data-test="event-repetition">{{ repetition }}</div>
        <div class="advanced-course-title" data-test="event-name">{{ courseName }}</div>
        <div class="d-flex flex-row course-dates" data-test="event-dates">
            {{ courseDates }}
            <div v-if="!hideEdit" @click="showModal = true" class="edit-text ml-3 cursor-pointer">
                Edit
            </div>
        </div>

        <EditCourseDatesModal
            v-if="showModal"
            :show-modal="showModal"
            :modal-spinner="showModalSpinner"
            :course="course"
            :time="courseDates"
            @close="showModal = false"
            @submit="submit"
            @delete="submitDelete"
        />
    </div>
</template>

<style scoped>
.title-sub-text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #999999;
}

.advanced-course-title {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 48px;
    color: #260045;
}

.edit-text {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    color: #260045;
}

.course-dates {
    color: #636066;
}

</style>
